/**
 * @generated SignedSource<<3f36b07d212ebe486ca258269be4084c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "TzzSignResponse",
    "kind": "LinkedField",
    "name": "tzzSign",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "location",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ImpulseTzzSignPaymentCheckoutPagesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ImpulseTzzSignPaymentCheckoutPagesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "ce74025939321416e594ff09efabad1f",
    "id": null,
    "metadata": {},
    "name": "ImpulseTzzSignPaymentCheckoutPagesMutation",
    "operationKind": "mutation",
    "text": "mutation ImpulseTzzSignPaymentCheckoutPagesMutation(\n  $request: TzzSignRequestInput\n) {\n  tzzSign(request: $request) {\n    location\n  }\n}\n"
  }
};
})();

node.hash = "3ced251617407ba9e1ca37bfe299b646";

module.exports = node;
